import styled from 'styled-components';

export const FiltrosDiv = styled.div`
    display: flex;
    flex-direction: row;    
`